export const heroTrainingText = {
  en: {
    title: "Become a Coach & Coaching Business",
    subtitle: "",
  },
  vi: {
    title: "Trở Thành Coach & Phát Triển Doanh Nghiệp Coaching",
    subtitle: "",
  },
};

export const quoteTrainingText = {
  en: {
    title: "Become a Certified Coach & Launch Your Coaching Business",
    desc: "Train with expert coaches and get the tools, guidance, and support to start and grow your own coaching business.",
    cta: "Join the Program",
  },
  vi: {
    title: "Trở thành Coach chuyên nghiệp & xây dựng sự nghiệp Coaching",
    desc: "Được đào tạo bởi các chuyên gia, trang bị công cụ, định hướng và hỗ trợ để bắt đầu và phát triển business coaching của riêng bạn.",
    cta: "Tham gia chương trình",
  },
};

export const trainingListData = {
  en: [
    {
      id: 1,
      icon: "GraduationCap",
      title: "About the Program",
      description:
        "Our Coach Training & Mentorship Group is designed for aspiring coaches who want to build a successful coaching career. This program not only teaches you expert coaching techniques but also equips you with the business skills and strategies to launch and run your own coaching practice.",
      bestFor: "Aspiring Coaches",
      list: [],
    },
    {
      id: 2,
      icon: "Users",
      title: "Program Benefits",
      description: "",
      bestFor: "Career & Business Growth",
      list: [
        "Master coaching techniques through hands-on mentorship and real-world practice",
        "Build your own coaching business with guidance from experienced professionals",
        "Join a supportive community of like-minded coaches for networking and growth",
        "Access resources and tools for ongoing business development and client acquisition",
      ],
    },
    {
      id: 3,
      icon: "Brain",
      title: "How It Works",
      description: "",
      bestFor: "Structured Learning Journey",
      list: [
        "Enroll in the program and complete the structured coaching curriculum",
        "Participate in live mentoring sessions with Maria and senior coaches",
        "Apply coaching techniques with practice clients in a supportive environment",
        "Receive guidance on business setup, marketing, and client management",
        "Join the Coach Mentorship Network for ongoing support and collaboration",
      ],
    },
  ],

  vi: [
    {
      id: 1,
      icon: "GraduationCap",
      title: "Giới Thiệu Chương Trình",
      description:
        "Nhóm Đào Tạo & Mentorship Coach của chúng tôi dành cho những người mong muốn trở thành coach chuyên nghiệp và xây dựng sự nghiệp thành công. Chương trình không chỉ đào tạo kỹ năng coaching chuyên sâu mà còn trang bị kiến thức và chiến lược kinh doanh để bạn khởi nghiệp và vận hành doanh nghiệp coaching riêng.",
      bestFor: "Người mong muốn trở thành Coach",
      list: [],
    },
    {
      id: 2,
      icon: "Users",
      title: "Lợi Ích Chương Trình",
      description: "",
      bestFor: "Phát triển sự nghiệp & kinh doanh",
      list: [
        "Làm chủ kỹ thuật coaching thông qua hướng dẫn thực hành và kinh nghiệm thực tế",
        "Xây dựng doanh nghiệp coaching riêng với sự hướng dẫn từ các chuyên gia dày dạn kinh nghiệm",
        "Tham gia cộng đồng hỗ trợ với các coach cùng chí hướng để kết nối và phát triển",
        "Truy cập tài nguyên và công cụ cho phát triển kinh doanh và tìm kiếm khách hàng liên tục",
      ],
    },
    {
      id: 3,
      icon: "Brain",
      title: "Cách Tham Gia Chương Trình",
      description: "",
      bestFor: "Lộ trình rõ ràng",
      list: [
        "Đăng ký chương trình và hoàn thành khóa đào tạo coaching có cấu trúc",
        "Tham gia các buổi mentoring trực tiếp cùng Maria và các coach cao cấp",
        "Thực hành kỹ thuật coaching với khách hàng thực tế trong môi trường hỗ trợ",
        "Nhận hướng dẫn về xây dựng doanh nghiệp, marketing và quản lý khách hàng",
        "Tham gia Nhóm Mentorship Coach để nhận hỗ trợ và hợp tác liên tục",
      ],
    },
  ],
};

export const trainingCTA = {
  en: {
    text: "Ready to start your coaching career and build a successful business?",
    button1: "Join the Program/ Start Your Coaching Business →",
    button2: "",
  },
  vi: {
    text: "Sẵn sàng bắt đầu sự nghiệp coaching và xây dựng doanh nghiệp thành công?",
    button1: "Tham Gia Chương Trình/ Khởi Nghiệp Coaching →",
    button2: "",
  },
};
